const eventBus = $({});

module.exports = eventBus;
